<template>
  <div class="rechargeRecord">
    <div class="filter-container">
      <span class="transTime">{{ $t('components.date') }}:</span>
      <!-- 提现时间 -->
      <el-date-picker
        v-model="search.times"
        size="small"
        class="mb-10 picker"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00','23:59:59']"
        type="daterange"
        range-separator="~"
        :start-placeholder="$t('components.start_date')"
        :end-placeholder="$t('components.end_date')"
      />
      <!--交易状态  -->
      <el-select v-model="search.status" size="small" class="search-frame status" :placeholder="$t('merchantAccount.po_trans_status')" clearable>
        <el-option
          :key="1"
          :label="$t('map.recharge_status_1')"
          :value="1"
        />
        <el-option
          :key="2"
          :label="$t('map.recharge_status_4')"
          :value="2"
        />
        <el-option
          :key="3"
          :label="$t('map.recharge_status_2')"
          :value="3"
        />
        <el-option
          :key="4"
          :label="$t('map.recharge_status_3')"
          :value="4"
        />
      </el-select>
      <!-- 查询 -->
      <el-button class="search-btn mb-10" size="small" type="primary" icon="el-icon-search" @click="getMchRechargeInfo">{{ $t('components.search') }}</el-button>
      <!-- 明细excel下载 -->
      <el-button class="mb-10 download-btn" size="small" type="info" :disabled="downloading" icon="el-icon-download" @click="onClickDowmloadBtn">{{ $t('components.download') }}</el-button>
    </div>
    <div class="tableContainer">
      <!-- 列表 -->
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
        class="tableContainer"
      >
        <!-- <el-table-column label="ID" align="center">
          <template slot-scope="scope">
            {{ scope.row.id }}
          </template>
        </el-table-column> -->

        <el-table-column :label="$t('merchantAccount.amount')" align="center" min-width="110">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.top_up_type === 4" placement="top" style="margin-right: 4px">
              <div slot="content" style="width: auto">
                <span>{{ $store.getters.isMX ? $t('tips.qr_tips') : $t('tips.thai_qr_tips') }} {{ $t('components.amount_to_receive') }}: {{ scope.row.actual_received_amount | toDivideWithDot }}</span>
              </div>
              <span> <svg-icon icon-class="icon-font-question" class="icon-question" /></span>
            </el-tooltip>
            <span>{{ scope.row.amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.payment_type')" align="center" min-width="130">
          <template slot-scope="scope">
            <el-tag :type="getRechargeTypeMap(scope.row.top_up_type).type">{{ getRechargeTypeMap(scope.row.top_up_type).label }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.bank')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.bank }}</span>
          </template>
        </el-table-column>

        <!-- 资金来源 -->
        <el-table-column :label="$t('merchantAccount.money_source')" align="center" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.money_source_defined || getFundsSourceMap(scope.row.money_source) }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.bank_account')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.bank_account }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.bank_account_name')" align="center" min-width="100px">
          <template slot-scope="scope">
            <span>{{ scope.row.bank_account_name }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.operator')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.operator ? scope.row.operator :'system' }}</span>
          </template>
        </el-table-column>

        <!-- 交易状态 -->
        <el-table-column :label="$t('merchantAccount.transaction_status')" align="center" min-width="110">
          <template slot-scope="{ row }">
            <div class="status-wrap">
              <el-tag class="tag-custom" :class="[getRechargeStatus(row).class ? getRechargeStatus(row).class : '']" :type="getRechargeStatus(row).type">{{ getRechargeStatus(row).label }}</el-tag>
              <div class="status-tip-wrap">
                <el-tooltip v-if="getRechargeStatus(row).value === 4" placement="top">
                  <div slot="content">
                    <span>{{ row.risk_remark }}</span>
                  </div>
                  <svg-icon icon-class="warning" />
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.create_time')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.create_time }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.update_time')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.update_time }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('components.operation')" align="center" min-width="200">
          <template slot-scope="{ row }">
            <el-button type="text" :disabled="getRechargeStatus(row).value !== 4" @click="reSubmit(row)">{{ $t('components.re_edit') }}</el-button>
            <el-button v-if="row.top_up_type === 4" :disabled="!(row.risk_status === 4 && row.payment_status === 1 && row.settle_status === 0)" type="text" @click="reSubmitQR(row)">{{ row.settle_status !== 2? $t('data.proceed_to_payment') : $t('data.pending_for_settlement') }}</el-button>
            <br>
            <div v-if="row.go_to_thai_qr_status === 1">({{ row.countdown }})</div>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
    </div>

  </div>
</template>

<script>

import { fetchMchRechargeList } from '@/api/settlement/settlement'
import { rechargeStatusMap, fundsSourceMap, rechargeTypeMap } from '@/utils/maps'
import { filterEmptyAttr, exportXlsx } from '@/utils/common'
import { appointDate } from '@/utils/index.js'

export default {
  name: 'Recharge_Record',
  components: {
    Paginator: () => import('@/views/components/Paginator')
  },
  data() {
    return {
      search: {
        status: null, // 交易状态
        times: [appointDate(-3) + ' 00:00:00', appointDate() + ' 23:59:59']
      },
      tableData: [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      downloading: false
    }
  },
  computed: {
    getRechargeStatus() {
      return function(item) {
        let value
        if (item.risk_status === 1) {
          value = 1
        } else if (item.risk_status === 2) {
          value = 4
        } else if (item.risk_status === 4 && item.payment_status === 1) {
          value = 1
        } else if (item.risk_status === 4 && item.payment_status === 2) {
          value = 2
        } else if (item.risk_status === 4 && item.payment_status === 3) {
          value = 3
        } else if (item.risk_status === 3 && item.payment_status === 1) {
          value = 1
        } else if (item.risk_status === 3 && item.payment_status === 3) {
          value = 3
        }
        const res = rechargeStatusMap(value)
        return { value, ...res }
      }
    },
    getFundsSourceMap() {
      return function(value) {
        return fundsSourceMap(value).label
      }
    },
    getRechargeTypeMap() {
      return value => rechargeTypeMap(value)
    }
  },
  created() {
    this.getMchRechargeInfo()
    document.addEventListener('visibilitychange', this.getMchRechargeInfo)
  },
  destroyed() {
    document.removeEventListener('visibilitychange', this.getMchRechargeInfo)
  },
  methods: {
    reSubmit(row) {
      this.$router.push({ name: 'Financial_Manage_Balance_Recharge', query: { id: row.id }})
    },
    reSubmitQR(row) {
      if (row.go_to_thai_qr_status === 1) {
        this.$confirm(
          `<span class="tip">${this.$t('data.thai_qr_tip_1')}<span style="color: red">${this.$t('data.one_hour')}</span>${this.$t('data.thai_qr_tip_2')}</span>`,
          this.$t('components.tips'),
          {
            confirmButtonText: this.$t('components.confirm'),
            cancelButtonText: this.$t('components.cancel'),
            type: 'warning',
            dangerouslyUseHTMLString: true
          }
        ).then(() => {
          this.$router.push({ name: 'Financial_Manage_Balance_Recharge_QR', query: { id: row.id }})
        })
      } else {
        this.$router.push({ name: 'Financial_Manage_Balance_Recharge_QR', query: { id: row.id }})
      }
    },
    getMchRechargeInfo(otherParams) {
      this.listLoading = true
      const params = this.getParams(otherParams)
      fetchMchRechargeList(params).then(res => {
        const { total, list = [] } = res.data
        this.listQuery.total = total
        this.listQuery.page = params.page ? params.page : 1
        this.tableData = list
        this.tableData = list.map(item => {
          // 这里假设每条记录有一个 endTime 属性表示倒计时结束的时间点
          const endTime = Math.floor(item.expires_time_stamp / 1000)
          const currentTime = Math.floor(item.current_time_stamp / 1000)
          const remainingSeconds = endTime - currentTime
          const minutes = Math.floor((remainingSeconds % 3600) / 60)
          const seconds = remainingSeconds % 60
          const countdown = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
          if (remainingSeconds < 0) {
            item.go_to_thai_qr_status = 2
          }
          return { ...item, remainingSeconds, countdown }
        })
        this.startCountdown()
        // 充值记录刷新时同步刷新账户余额（可用余额等）
        this.$emit('get-merchant-info')
      }).finally(() => {
        this.listLoading = false
      })
    },
    startCountdown() {
      if (this.intervalId) {
        clearInterval(this.intervalId)
      }
      this.intervalId = setInterval(() => {
        this.updateCountdown()
        this.startCountdown()
      }, 1000)
    },
    updateCountdown() {
      this.tableData = this.tableData.map(item => {
        if (item.remainingSeconds > 0) {
          item.remainingSeconds -= 1
        } else {
          item.go_to_thai_qr_status = 2
        }
        const minutes = Math.floor((item.remainingSeconds % 3600) / 60)
        const seconds = item.remainingSeconds % 60
        item.countdown = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
        return item
      })
    },
    getParams(otherParams = {}) {
      const { status, times = [] } = this.search
      let params = { start_date_time: times && times[0], end_date_time: times && times[1], status, ...otherParams }
      params = filterEmptyAttr(params)
      return params
    },

    onClickDowmloadBtn() {
      const params = this.getParams()
      params.page = 0
      this.downloading = true
      fetchMchRechargeList(params).then(res => {
        this.$message.success('Start downloading!')
        this.handleXlsxData(res.data.list).then((downloadData) => {
          exportXlsx(downloadData, 'Recharge_Record')
        })
      }).finally(() => {
        setTimeout(() => {
          this.downloading = false
        }, 3000)
      })
    },

    handleXlsxData(data = []) {
      const rows = [[
        this.$t('merchantAccount.transaction_amount'),
        this.$t('data.payment_type'),
        this.$t('merchantAccount.bank'),
        this.$t('merchantAccount.money_source'),
        this.$t('merchantAccount.bank_account'),
        this.$t('merchantAccount.bank_account_name'),
        this.$t('merchantAccount.operator'),
        this.$t('merchantAccount.transaction_status'),
        this.$t('merchantAccount.create_time'),
        this.$t('merchantAccount.update_time')
      ]]

      const toDivide100 = this.$options.filters['toDivide100']
      if (Array.isArray(data) && data.length > 0) {
        data.forEach((tr) => {
          rows.push([
            toDivide100(tr.amount),
            this.getRechargeTypeMap(tr.top_up_type).label,
            tr.bank,
            tr.money_source_defined || this.getFundsSourceMap(tr.money_source),
            tr.bank_account,
            tr.bank_account_name,
            tr.operator ? tr.operator : 'system',
            this.getRechargeStatus(tr).label,
            tr.create_time,
            tr.update_time
          ])
        })
      }
      return Promise.resolve(rows)
    },

    onClickPaginator() {
      this.getMchRechargeInfo(this.listQuery)
    }
  }
}
</script>

<style lang="scss" scoped>
.rechargeRecord{
  background-color: #fff;
  .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Inter-Medium';
    color: #606266;
  }
  .filter-container{
    margin-top: 14px;
    margin-bottom: 32px;
    text-align: right;
  }
  .search-frame {
    width: 160px;
    margin-right: 5px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .picker{
    margin-right: 5px;
  }
  .status{
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
  .mb-10{
    margin-bottom: 10px;
  }
}
.status-wrap {
  display: inline-block;
  position:relative;
  .status-tip-wrap {
    position:absolute;
    top:40%;
    transform:translateY(-50%);
    right:-20px;
  }
}
.icon-question{
  position: relative;
  top: -1px;
  margin-left: 5px;
  font-size: 8px;
}
</style>
